import { Button, Center, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Center minH={"60vh"}>
      <VStack maxW={"460px"}>
        <Heading as={"h1"}>404</Heading>
        <Text mb={4} textStyle={"header1"} textAlign={"center"}>
          It looks like we couldn't find the the page you were looking for...
        </Text>

        <Button
          mb={-1}
          variant={"link"}
          onClick={() => {
            navigate(-1);
          }}
          textDecoration={"underline"}
          fontSize={"16px"}
        >
          Return to previous page
        </Button>
        <a href="/" className="font-semibold text-gray-600 text-lg underline">
          Home
        </a>
      </VStack>
    </Center>
  );
};

export default NotFound;
